import AWS from "aws-sdk";
import { signedUrlExpireSeconds } from "../utils/constants";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: "ap-southeast-1",
  signatureVersion: "v4",
});
const s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: process.env.REACT_APP_AWS_BUCKET },
});
export default function useAWSUpload() {
  const uploadFile = async (file) => {
    const params = {
      Body: file,
      Bucket: process.env.REACT_APP_AWS_BUCKET + "/test",
      Key: file.name,
    };

    let upload = new AWS.S3.ManagedUpload({
      params,
    });

    return await upload.promise();
  };

  const getSignedUrl = (Key) => {
    return s3.getSignedUrl("getObject", {
      Bucket: process.env.REACT_APP_AWS_BUCKET,
      Key,
      Expires: signedUrlExpireSeconds,
    });
  };

  return [getSignedUrl, uploadFile];
}
